import script from "./Detalles.vue?vue&type=script&setup=true&lang=js"
export * from "./Detalles.vue?vue&type=script&setup=true&lang=js"

import "./Detalles.vue?vue&type=style&index=0&id=c609eba8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c609eba8"]])

export default __exports__